import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/camion.svg';
export default {
  name: 'Delivery',

  data() {
    return {};
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    urlPrefix() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    }

  })
};